export default "__VITE_ASSET__7b6f422d__"